import { 
    MessageResponseDto, 
    GetWaiverDto, 
    CreateWaiverDto, 
    EditWaiverDto,
    WaiverControllerGet200Response,
    WaiverApiFp,
    DeleteWaiverDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseWaiverModel = WaiverControllerGet200Response;
export type GetWaiverModel = GetWaiverDto;
export type MutateResponseWaiverModel = MessageResponseDto;
export type CreateWaiverModel = CreateWaiverDto;
export type UpdateWaiverModel = EditWaiverDto;
export type DeleteWaiverModel = DeleteWaiverDto;

export const apiWaiverFp = WaiverApiFp(apiConfig);
export const getWaiverController = apiWaiverFp.waiverControllerGet;
export const createWaiverController = apiWaiverFp.waiverControllerCreate;
export const updateWaiverController = apiWaiverFp.waiverControllerEdit;
export const deleteWaiverController = apiWaiverFp.waiverControllerDelete;

export const QueryKeyWaiver = QueryKey.Waiver;